import {QuestionsComponent} from '@components/competitions/levels/tekyehmajazi/QuestionsComponent';
import {useCompetitionTekyehmajaziContext} from '@context/CompetitionTekyehmajaziContext';
import {Divider, LinearProgress, linearProgressClasses, styled, useTheme} from '@mui/material';
import MaximizableView from '@utils/MaximizableView';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import ReactPlayer from 'react-player';
// import {ParticlesContainer} from '@components/uikit/particles';

type IProps = {
	state?: string
}
// const defaultUrl = 'https://files.novinrazavi.ir/competition/f33dbb7b-9f92-44fa-87a6-23dcbebddd68.mp4';
const defaultUrl = 'https://stream01.gaplication.com/hls/Razavi1400bdisosvxpevqy/index.m3u8';

export default function Mission0(props: IProps) {
	const {state} = props;
	
	const theme = useTheme();
	const {t} = useTranslation();
	
	// -----------
	const player = useRef<ReactPlayer>(null);
	const [showDialog1, setShowDialog1] = useState<boolean>(true);
	const [showDialog2, setShowDialog2] = useState<boolean>(false);
	const [progress, setProgress] = useState(0);
	const [remaining, setRemaining] = useState(0);
	const [url, setUrl] = useState('');
	const [isPlaying, setIsPlaying] = useState(false);
	const [videoEnd, setVideoEnd] = useState(false);
	const [buffer, setBuffer] = useState(10);
	const [videoLoading, setVideoLoading] = useState(false);
	const [played, setPlayed] = useState(0);
	const [duration, setDuration] = useState(0);
	
	useEffect(() => {
		setUrl(defaultUrl);
	}, [url]);
	const {
		competition,
		mission,
		setMission,
		phone,
		setPhone
	} = useCompetitionTekyehmajaziContext();
	
	// useEffect(() => {
	// 	if (social == '') {
	// 		let socialGroup = referrerFinder(referrerFrom) ?? '';
	// 		setSocial(socialGroup);
	// 		// console.log(socialGroup, referrerFrom);
	// 	}
	// }, [referrerFrom]);
	// useEffect(() => {
	// 	const timer = setInterval(() => {
	// 		setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
	// 	}, 800);
	// 	return () => {
	// 		clearInterval(timer);
	// 	};
	// }, []);
	const onPlayClick = () => {
		// props.playerRef?
		setIsPlaying(() => !isPlaying);
	};
	
	function onPause() {
		setIsPlaying(false);
		// setShowDialog1(true);
		setShowDialog2(true);
	}
	
	function onEnded() {
		setVideoEnd(true);
		setIsPlaying(false);
		setShowDialog2(true);
	}
	
	const handleSeekChange = (e: {target: {value: string;};}) => {
		setPlayed(parseFloat(e.target.value));
	};
	
	function onProgress(value: any) {
		let remaining = duration * (1 - value.played);
		setProgress(100 * value.played);
		setBuffer(100 * value.loaded);
		setRemaining(remaining);
	}
	
	const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
		height: 5,
		borderRadius: 5,
		'&.MuiLinearProgress-colorPrimary:not(.MuiLinearProgress-buffer)': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-colorPrimary': {
			backgroundColor: theme.palette.mode === 'light' ? '#62b694' : '#62b694'
		},
		'& .MuiLinearProgress-barColorPrimary': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-buffer': {
			backgroundColor: '#0b152b'
		},
		'& .MuiLinearProgress-bar1Buffer': {
			backgroundColor: '#0b152b'
		},
		// ['& .MuiLinearProgress-dashedColorPrimary']: {
		// 	backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
		// 	// 'radial-gradient(#3d73e8 0%, #3d73e8 16%, transparent 42%)'
		// },
		[`&.${linearProgressClasses.colorPrimary}`]: {
			backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
		}
		// [`& .${linearProgressClasses.bar}`]: {
		// 	borderRadius: 5,
		// 	backgroundColor: theme.palette.mode === 'light' ? '#0b152b' : '#0b152b'
		// }
	}));
	return (
		<>
			<div className="w-full h-screen chat-words-choice overflow-y-scroll">
				<Divider className="h-14"/>
				<MaximizableView backgroundColor="#004038" remaining={remaining} videoEnd={videoEnd} mission={mission}>
					<div
						className="h_iframe-aparat_embed_frame w-11/12 h-72 flex flex-row justify-center items-center m-auto border-8 border-[#004038] rounded-2xl overflow-hidden">
						{/*@ts-ignore*/}
						<iframe className={'z-50'} scrolling="no" allowFullScreen={true} webkitallowfullscreen={true}
						        mozallowfullscreen={true} src="https://www.aparat.com/embed/live/aqr_ir"></iframe>
					</div>
				</MaximizableView>
				{/*<MaximizableView backgroundColor="#efefef" remaining={remaining} videoEnd={videoEnd} mission={mission}>*/}
				{/*	<Box className="w-full flex flex-col justify-center items-center">*/}
				{/*		<div*/}
				{/*			className="video-wrapper w-11/12 h-auto m-auto rounded-2xl cursor-pointer border-2 mt-5 relative bg-[#00da92]"*/}
				{/*			onClick={onPlayClick}>*/}
				{/*			{*/}
				{/*				remaining == 0 && !videoEnd && (*/}
				{/*					<div*/}
				{/*						className="w-[100%] h-[100%] absolute flex flex-row justify-center items-center bg-[#00da92] rounded-2xl">*/}
				{/*						<div className="">*/}
				{/*							<CircularProgress size={40} style={{color: '#0b152b'}}/>*/}
				{/*						</div>*/}
				{/*					</div>*/}
				{/*				)*/}
				{/*			}*/}
				{/*			<ReactPlayer*/}
				{/*				width={'100%'}*/}
				{/*				height={'100%'}*/}
				{/*				// ref={props.playerRef}*/}
				{/*				ref={player}*/}
				{/*				// ref={videoPlayerRef}*/}
				{/*				controls={false}*/}
				{/*				className="react-player outline-none rounded-2xl overflow-hidden"*/}
				{/*				url={url}*/}
				{/*				playing={isPlaying}*/}
				{/*				// onBuffer={() => setVideoLoading(true)}*/}
				{/*				onPlay={() => setIsPlaying(true)}*/}
				{/*				onPause={onPause}*/}
				{/*				onEnded={onEnded}*/}
				{/*				onProgress={onProgress}*/}
				{/*				onDuration={setDuration}*/}
				{/*				// onSeek={handleSeekChange}*/}
				{/*				// onSeek={e => console.log('onSeek', e)}*/}
				{/*				// height={props.height}*/}
				{/*				// width={props.width}*/}
				{/*				// loop={true}*/}
				{/*				// controls={true}*/}
				{/*				// url={props.file}*/}
				{/*				// playIcon={<PlayArrowIcon/>}*/}
				{/*			/>*/}
				{/*		</div>*/}
				{/*		{*/}
				{/*			remaining !== 0 && !videoEnd && (*/}
				{/*				<div className="w-5/6 flex flex-col items-center justify-between">*/}
				{/*					<div className="w-full h-8 flex flex-row ltr justify-center items-center mt-2 content-center">*/}
				{/*						<div onClick={onPlayClick}*/}
				{/*						     className="w-8 h-auto p-2 flex flex-col content-center justify-center items-center cursor-pointer bg-white rounded-full">*/}
				{/*							{isPlaying ?*/}
				{/*								<img src={media_pause} alt={'media_pause'} className="w-3 h-auto"/> :*/}
				{/*								<img src={media_play} alt={'media_play'} className="w-3 h-auto"/>}*/}
				{/*						</div>*/}
				{/*						<div className="w-11/12 mx-2">*/}
				{/*							<BorderLinearProgress*/}
				{/*								variant="buffer"*/}
				{/*								value={progress}*/}
				{/*								valueBuffer={buffer}*/}
				{/*								sx={{*/}
				{/*									direction: 'ltr'*/}
				{/*								}}*/}
				{/*							/>*/}
				{/*							/!*<LinearProgress*/}
				{/*							 variant={'buffer'}*/}
				{/*							 value={progress}*/}
				{/*							 valueBuffer={buffer}*/}
				{/*							 classes={{*/}
				{/*							 barColorPrimary: '#0b152b'*/}
				{/*							 }}*/}
				{/*							 />*!/*/}
				{/*						</div>*/}
				{/*					</div>*/}
				{/*					/!*<div className="cursor-pointer" onClick={() => {*!/*/}
				{/*					/!*	toggleFullScreen();*!/*/}
				{/*					/!*}}>*!/*/}
				{/*					/!*	<img src={media_fullscreen} alt={'media_fullscreen'} className="w-24 h-auto mt-8"/>*!/*/}
				{/*					/!*</div>*!/*/}
				{/*				</div>*/}
				{/*			)*/}
				{/*		}*/}
				{/*	</Box>*/}
				{/*</MaximizableView>*/}
				{/*</div>*/}
				<div className="w-11/12 flex flex-col justify-center items-center mt-5 mx-auto">
					{/*{remaining.toFixed(0)}*/}
					{/*<Duration seconds={remaining} className="font-bold"/>*/}
					{/*<img className="w-14 mb-3" src={sand} alt="sand"/>*/}
					<QuestionsComponent/>
				</div>
			</div>
			{/*{*/}
			{/*	showDialog1 && (*/}
			{/*		<Box className="w-full h-full bg-white/90 absolute top-[55px] right-0 bottom-0 left-0">*/}
			{/*			<Box*/}
			{/*				// sx={{*/}
			{/*				// 	backgroundImage: `url(${bgPopup})`,*/}
			{/*				// 	backgroundRepeat: 'no-repeat',*/}
			{/*				// 	backgroundSize: 'contain'*/}
			{/*				// }}*/}
			{/*				className="w-5/6 h-40 mx-auto relative top-[30%] bg-[#081628] rounded-3xl"*/}
			{/*			>*/}
			{/*				<div className="flex flex-col w-full h-40 justify-center items-center gap-y-5">*/}
			{/*					<div className="w-4/6">*/}
			{/*						<img className="w-full" src={fullView} alt="title"/>*/}
			{/*					</div>*/}
			{/*					<div className="flex flex-row gap-x-10 w-1/6 bg-white p-2 rounded-2xl">*/}
			{/*						<img className="w-full" src={continueText} alt="title" onClick={() => {*/}
			{/*							setVideoEnd(false);*/}
			{/*							setShowDialog1(false);*/}
			{/*						}}/>*/}
			{/*					</div>*/}
			{/*				</div>*/}
			{/*			</Box>*/}
			{/*		</Box>*/}
			{/*	)*/}
			{/*}*/}
			{/*{*/}
			{/*	showDialog2 && (*/}
			{/*		<Box className="w-full h-full bg-white/90 absolute top-[55px] right-0 bottom-0 left-0">*/}
			{/*			<Box*/}
			{/*				// sx={{*/}
			{/*				// 	backgroundImage: `url(${bgPopup})`,*/}
			{/*				// 	backgroundRepeat: 'no-repeat',*/}
			{/*				// 	backgroundSize: 'contain'*/}
			{/*				// }}*/}
			{/*				className="w-5/6 h-40 mx-auto relative top-[30%] bg-[#081628] rounded-3xl"*/}
			{/*			>*/}
			{/*				<div className="flex flex-col w-full h-40 justify-center items-center gap-y-5">*/}
			{/*					<div className="w-4/6">*/}
			{/*						<img className="w-full" src={popup2q} alt="title"/>*/}
			{/*					</div>*/}
			{/*					<div className="flex flex-row gap-x-10 w-9/12 justify-center items-center content-center">*/}
			{/*						<div className="bg-white h-8 rounded-2xl py-1 px-4 cursor-pointer flex justify-center" onClick={() => {*/}
			{/*							setMission(2);*/}
			{/*						}}>*/}
			{/*							<img className="w-full" src={popup2a1} alt="title"/>*/}
			{/*						</div>*/}
			{/*						<div className="bg-white h-8 rounded-2xl py-1 px-4 cursor-pointer flex justify-center" onClick={() => {*/}
			{/*							setIsPlaying(true);*/}
			{/*							setShowDialog2(false);*/}
			{/*						}}>*/}
			{/*							<img className="w-full" src={popup2a2} alt="title"/>*/}
			{/*						</div>*/}
			{/*					</div>*/}
			{/*				</div>*/}
			{/*			</Box>*/}
			{/*		</Box>*/}
			{/*	)*/}
			{/*}*/}
		</>
	);
}
// replaceChars(totalWords[wordIndex].text, randomIntArrayInRange(1, totalWords[wordIndex].text, totalWords[wordIndex].hiddenCount), ' _ ');
